import { ITEMS, type ItemId, type ItemDef } from '../config/gameConfig';

export class Inventory {
  private items: ItemId[] = [];
  selected: ItemId | null = null;
  onChange: (() => void) | null = null;

  has(id: ItemId): boolean {
    return this.items.includes(id);
  }

  list(): ItemDef[] {
    return this.items.map((id) => ITEMS[id]);
  }

  add(id: ItemId): boolean {
    if (this.has(id)) return false;
    this.items.push(id);
    this.selected = id;
    this.onChange?.();
    return true;
  }

  remove(id: ItemId): void {
    this.items = this.items.filter((x) => x !== id);
    if (this.selected === id) this.selected = this.items[0] ?? null;
    this.onChange?.();
  }

  select(id: ItemId | null): void {
    if (id && !this.has(id)) return;
    this.selected = id;
    this.onChange?.();
  }

  cycle(): void {
    if (this.items.length === 0) {
      this.selected = null;
      return;
    }
    if (!this.selected) {
      this.selected = this.items[0];
    } else {
      const i = this.items.indexOf(this.selected);
      this.selected = this.items[(i + 1) % this.items.length];
    }
    this.onChange?.();
  }
}
